"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traced = void 0;
function traced(contextParameterIndex = 0) {
    return (target, propertyName, descriptor) => {
        console.log(target, propertyName, descriptor);
        const originalMethod = descriptor.value;
        descriptor.value = function () {
            const targetClass = this;
            const parentContext = arguments[contextParameterIndex];
            const parentSpan = parentContext.getSpan();
            const newArguments = [...arguments];
            let span;
            if (parentSpan) {
                span = targetClass.getTracer().startSpan(targetClass.constructor.name + '::' + propertyName, { childOf: parentContext.getSpan() });
                newArguments[contextParameterIndex] = parentContext.withSpan(span);
            }
            if (originalMethod) {
                const returnValue = originalMethod.apply(this, newArguments);
                if ("then" in returnValue) {
                    return returnValue.then((result) => {
                        span && span.finish();
                        return result;
                    });
                }
                span && span.finish();
                return returnValue;
            }
        };
    };
}
exports.traced = traced;
//# sourceMappingURL=tracingHelper.js.map